import {momentRange} from "../../../../../gd/convert/moment-range";
import formatDaterange from "../../../../../gd/format/daterange";

export default class ReportProgressReport_Settings {

    public daterange        : DateRange
    public projectIds       : ID[] | null
    public taskTypeIds      : ID[]


    constructor(data: any) {
        this.daterange        = data?.daterange ? momentRange(data.daterange.start, data.daterange.end) : momentRange(moment().subtract(1, "month"), moment())
        this.projectIds       = _.get(data, "projectIds", [])
        this.taskTypeIds      = _.get(data, "taskTypeIds", [])
    }

    get reportTitle() {
        return formatDaterange(this.daterange)
    }

    toJSON(): JSONObject {
        const result: JSONObject = {
            projectIds      : this.projectIds,
            taskTypeIds     : this.taskTypeIds,

        }

        if (this.daterange) {
            result['daterange'] = {
                start   : this.daterange.start.format("YYYY-MM-DD"),
                end     : this.daterange.end.format("YYYY-MM-DD")
            }
        }

        return result
    }
}
